var map = {
	"./Bands1.jpg": 94716,
	"./Bands2.jpg": 62411,
	"./Drums1.jpg": 73193,
	"./Drums2.jpg": 30110,
	"./DrumsScore1-KELsMUSIC.jpg": 686,
	"./DrumsScore2-KELsMUSIC.jpg": 40493,
	"./Guitar1.jpg": 43134,
	"./JMC1.jpg": 26358,
	"./JMC2.jpg": 75969,
	"./Piano1.jpg": 31901,
	"./Piano2.jpg": 38354,
	"./PianoScore1-KELsMUSIC.jpg": 18786,
	"./PianoScore2-KELsMUSIC.jpg": 59921,
	"./PianoScore3-KELsMUSIC.jpg": 4,
	"./Violin1.jpg": 98037,
	"./Violin2.jpg": 22314,
	"./ViolinScore1-KELsMUSIC.jpg": 73002,
	"./ViolinScore2-KELsMUSIC.jpg": 84793,
	"./Vocals1.jpg": 52946,
	"./pianoResult.jpg": 5273,
	"./violinResult.jpg": 75505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17709;